const getters = {
  token: state => state.user.token,
  permission_routers: state => state.user.routers,
  usuario: state => state.user.usuario,
  drawer: state => state.user.drawer,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  role: state => state.user.usuario.role,
  setting: state => state.user.setting,
  home_page: state => state.user.home_page,
  endereco: state => state.app.endereco,
  colors: state => state.app.colors,

  materiaisconsumo: state => state.consumomaterial.materiais,
  transportadores: state => state.transportador.transportadores
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js